<style lang="less" scoped>
.guider {
  background: #fff;
  padding: 45px 0.83333rem 0.83333rem;
}
.content {
  padding: 5px 0 10px;
  box-sizing: border-box;
  border-bottom: 0.5px dashed #4f5858;
  img {
    width: 15px;
    vertical-align: middle;
    margin-right: 5px;
  }
}

.content a {
  font-family: PingFang-SC-Regular;
  font-size: 10px;
  color: #0f5bd2;
  letter-spacing: 0;
  display: inline-block;
}
.content span:first-child {
  color: #101010;
  margin-bottom: 0.625rem;
  margin-top: 1.5625rem;
  font-family: "PingFang SC Medium";
  font-weight: 550;
  font-size: 12px;
}
.content i {
  font-style: normal;
}
.content .edit {
  font-size: 0.83333rem;
  color: #4f5858;
  letter-spacing: 0;
  // text-align: justify;
  margin-top: 8px;
  line-height: 1.66667rem;
  img {
    width: 8.33333rem;
    border: 1px dashed #b0acac;
    padding: 2px;
  }
}
.content .time {
  font-size: 10px;
  letter-spacing: 0;
  color: #000;
  font-weight: normal;
}
</style>
<template>
  <section>
    <div class="guider">
      <div class="content">
        <span>
          <img src="@/assets/images/stand.png" />{{ $t("header.home19") }}
        </span>
        <div class="mission">
          <div class="word">
            <p class="edit">
              <img src="@/assets/images/iana.jpg" />
              {{ $t("result.content5") }}
            </p>

            <a
              class="link"
              href="https://www.iana.org/assignments/uri-schemes/uri-schemes.xhtml"
              target="_blank"
              >https://www.iana.org/assignments/uri-schemes/uri-schemes.xhtml</a
            >
          </div>
        </div>
      </div>
      <div class="content">
        <span>
          <img src="@/assets/images/stand.png" />{{ $t("header.home23") }}
        </span>

        <div class="mission">
          <div class="word">
            <p class="edit">
              <img src="@/assets/images/logo_en.png" />{{
                $t("result.content20")
              }}
            </p>

            <a
              class="link"
              href="https://www.cstr.cn/image/food.png"
              target="_blank"
              >https://www.cstr.cn/image/food.png</a
            >
          </div>
        </div>
      </div>
      <div class="content">
        <div class="mission">
          <div class="word">
            <p class="edit">
              <img src="@/assets/images/icon/datacite.svg" />{{
                $t("result.content25")
              }}
            </p>

            <a
              href="https://www.cstr.cn/image/datacite.png"
              target="_blank"
              class="link"
              >https://www.cstr.cn/image/datacite.png
            </a>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="mission">
          <div class="word">
            <p class="edit">
              <img src="@/assets/images/icon/harvard.png" />{{
                $t("result.content23")
              }}
            </p>

            <a
              href="https://dataverse.harvard.edu/dataset.xhtml?persistentId=doi:10.7910/DVN/BRIJEC"
              target="_blank"
              class="link"
              >https://dataverse.harvard.edu/dataset.xhtml?persistentId=doi:10.7910/DVN/BRIJEC
            </a>
          </div>
        </div>
      </div>

      <div class="content">
        <div class="mission">
          <div class="word">
            <p class="edit">
              <img src="@/assets/images/icon/epic.png" />{{
                $t("result.content24")
              }}
            </p>

            <a href="http://www.pidconsortium.net/" target="_blank" class="link"
              >http://www.pidconsortium.net/
            </a>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="mission">
          <div class="word">
            <p class="edit">
              <img src="@/assets/images/orcid.svg" />{{
                $t("result.content21")
              }}
            </p>
            <a
              href="https://pub.orcid.org/v3.0/identifiers"
              target="_blank"
              class="link"
              >https://pub.orcid.org/v3.0/identifiers</a
            >
          </div>
        </div>
      </div>
      <div class="content">
        <div class="mission">
          <div class="word">
            <p class="edit">
              <img
                style="width: 50px; height: 50px"
                src="@/assets/images/icon/identifiers.png"
              />{{ $t("result.content29") }}
            </p>

            <a
              href="https://registry.identifiers.org/registry/cstr"
              class="link"
              >https://registry.identifiers.org/registry/cstr
            </a>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="mission">
          <div class="word">
            <p class="edit">
              <img style="width: 50%" src="@/assets/images/icon/global.png" />{{
                $t("result.content33")
              }}
            </p>
            <a href="https://goscloud.net/serviceCatalogue" class="link"
              >https://goscloud.net/serviceCatalogue
            </a>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="mission">
          <div class="word">
            <p class="edit">
              <img
                style="width: 50px; height: 50px"
                src="@/assets/images/icon/itu.png"
              />{{ $t("result.content26") }}
            </p>
            <a href="https://www.itu.int/en/Pages/default.aspx" class="link"
              >https://www.itu.int/en/Pages/default.aspx
            </a>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="mission">
          <div class="word">
            <p class="edit">
              <img
                style="width: 30%"
                src="@/assets/images/icon/crossref.jpg"
              />{{ $t("result.content27") }}
            </p>
            <a href="https://www.crossref.org/" class="link"
              >https://www.crossref.org/
            </a>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="mission">
          <div class="word">
            <p class="edit">
              <img style="width: 20%" src="@/assets/images/icon/raid.png" />{{
                $t("result.content28")
              }}
            </p>
            <a href="https://www.raid.org.au/" class="link"
              >https://www.raid.org.au/
            </a>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="mission">
          <div class="word">
            <p class="edit">
              <img style="width: 30%" src="@/assets/images/icon/stm.png" />{{
                $t("result.content34")
              }}
            </p>
            <a href="https://www.stm-assoc.org/about-stm/"
              >https://www.stm-assoc.org/about-stm/</a
            >
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {
      lang: "",
    };
  },
  mounted() {
    this.lang = this.$cookie.get("lang");
  },
};
</script>